
import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GcmAppComponent, GcmLoadingService } from '@gcm/gcm-ui-angular';
import { AuthService } from '@auth0/auth0-angular';
import { UserProfileComponent } from './components/user-profile';
import { SidebarComponent } from './components/sidebar/sidebar.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [GcmAppComponent, UserProfileComponent, SidebarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private auth = inject(AuthService);
  private router = inject(Router);

  constructor(public loader: GcmLoadingService) { }

  ngOnInit(): void {
    this.auth.appState$.subscribe((appState) => {
      if (appState?.target) {
        this.router.navigateByUrl(appState.target);
      }
    });
  }
}
